module.exports = __webpack_public_path__ + "img/success-icon.da6b388c.png";